import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { css, StyleSheet } from 'aphrodite';
import Select from 'react-select';

import { InfluenceStatusOptions } from 'lib/enums/InfluenceStatus';

function InfluenceStatusEditor({ value, onChange }) {
  const [selectedOption, setSelectedOption] = useState(value);
  return (
    <div className={css(styles.container)}>
      <Select
        isClearable
        autoFocus
        options={InfluenceStatusOptions}
        value={InfluenceStatusOptions.find(opt => opt.value === selectedOption) || null}
        placeholder="None"
        onChange={option => {
          setSelectedOption(option?.value || null);
          onChange(option?.value || null);
        }}
      />
    </div>
  );
}

const styles = StyleSheet.create({
  container: {
    minWidth: '400px',
  },
});

InfluenceStatusEditor.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default InfluenceStatusEditor;
